import {
  QA_NAME_ATTACH_BTN,
  QA_NAME_CANCEL_BTN,
} from '../../../../constants/qa'
import { Buttons } from '../../../Modal'
import {
  TableModalButtonCancel,
  TableModalButtonConfirm,
} from '../../../TableModal'

//in the next version the actions will be replaced by the Confirm button and a dropdown with actions

function Actions({
  ButtonAttach = TableModalButtonConfirm,
  ButtonCancel = TableModalButtonCancel,
  Component = Buttons,
  buttonAttachProps,
  buttonCancelProps,
  children,
  componentProps,
  isSkeleton,
  readonly,
}) {
  return (
    <Component {...componentProps} size='l'>
      {ButtonAttach && !readonly ? (
        <ButtonAttach
          {...buttonAttachProps}
          isSkeleton={isSkeleton}
          qaName={QA_NAME_ATTACH_BTN}
          text='Modal.AttachBtnKey'
        />
      ) : null}
      {ButtonCancel && !readonly ? (
        <ButtonCancel
          {...buttonCancelProps}
          isSkeleton={isSkeleton}
          qaName={QA_NAME_CANCEL_BTN}
        />
      ) : null}
      {children}
    </Component>
  )
}

export default Actions
